import React from 'react';
import styles from 'v2/common/Activity/activityAssociations.module.scss';

export interface ActivityAssociationWithoutContentProps {
  label: string;
}

const ActivityAssociationWithoutContent = ({
  label,
}: ActivityAssociationWithoutContentProps) => {
  const msg =
    `No ${label.toLocaleLowerCase()}` +
    ` found. Search above to find additional results.`;

  return (
    <div key={label} className="flex flex-row mt-3">
      <p className={styles.categoryTitle}>{label}</p>
      <span className={styles.noAssociations} data-testid={`noFound_${label}`}>
        {msg}
      </span>
    </div>
  );
};

export default ActivityAssociationWithoutContent;
